/**
 * Idempotency key for one-time-code verification calls (login and signup):
 * reusing it across retries lets the server recover a lost response instead
 * of double-consuming the code.
 */
export default function generateVerificationRequestId(): string {
  if (
    typeof crypto !== "undefined" &&
    typeof crypto.randomUUID === "function"
  ) {
    return crypto.randomUUID();
  }

  // requestId is an idempotency key, not a credential. Old browsers and the
  // test DOM may lack Web Crypto; preserve UUID shape with a uniqueness-only
  // fallback so the server can still validate and deduplicate the request.
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (char) => {
    const random = Math.floor(Math.random() * 16);
    const value = char === "x" ? random : 8 + (random % 4);
    return value.toString(16);
  });
}
